import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { VolunteerOrgProjectAssignment } from "../volunteer-org-project-assignment";
import { VolunteerOrgProjectEntityConfig } from "./config";
import { VolunteerOrgProjectFilters } from "./filters";
import { VolunteerOrgProjectMethods } from "./methods";

@HyperEntity("volunteer-org-project", VolunteerOrgProjectEntityConfig)
export class VolunteerOrgProject extends extender(
  VolunteerOrgProjectFilters,
  VolunteerOrgProjectMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ caption: "שם" })
  name = "";

  @Fields.string({ allowNull: true, caption: "תיאור" })
  description?: string | null;

  @Fields.boolean({ dbName: "is_active", caption: "פעיל" })
  isActive = true;

  @Relations.toMany(() => VolunteerOrgProjectAssignment, {
    field: "projectId",
  })
  assignments?: VolunteerOrgProjectAssignment[];

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
